import { applyMiddleware, createStore } from 'redux';
import { initialize, addTranslationForLanguage } from 'react-localize-redux';
import { renderToStaticMarkup } from 'react-dom/server';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import Cookies from 'js-cookie';
import { AVAILABLE_LANGUAGES, LANG_COOKIE_NAME } from './constants';
import reducers from './reducers';
import { translations } from './i18n/index';
import { get, set, isLocalStorageSupported } from './localStorage';

const getPersistedState = () => get() || {};

const persistState = (state) => set(state);

const getMiddlewares = () => {
  const reduxMiddlewares = [promiseMiddleware, thunk];

  if (process.env.NODE_ENV === 'development') {
    reduxMiddlewares.push(logger);
  }

  return reduxMiddlewares;
};

export default () => {
  const cookieLang = Cookies.get(LANG_COOKIE_NAME);
  const store = createStore(reducers, getPersistedState(), applyMiddleware(...getMiddlewares()));

  if (isLocalStorageSupported) {
    store.subscribe(() => {
      const { survey, surveySchema } = store.getState();
      persistState({ survey, surveySchema });
    });
  }

  store.dispatch(initialize({
    languages: AVAILABLE_LANGUAGES,
    options: { defaultLanguage: cookieLang || AVAILABLE_LANGUAGES[0], renderToStaticMarkup }
  }));

  AVAILABLE_LANGUAGES.forEach((code) =>
    store.dispatch(addTranslationForLanguage(translations[code], code)));

  return store;
};
